export enum CarouselType {
  Building = 'building',
  CustomCard = 'customCard',
  Product = 'product',
}
